export default {
  title: 'Bestellung verfolgen',
};
